import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Your first NextJS app – CodeWithSwiz",
  "description": "On CodeWithSwiz ep2, we tried NextJS and built our first tiny app. Complete with a design system, static rendering, React Query to talk to AWS Lambda, and deployed to live 🤘",
  "published": "2020-09-01T00:00:00.000Z",
  "categories": "CodeWithSwiz, Livecoding, Technical",
  "hero": "./img/The-end-resulthiibjh.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`CodeWithSwiz is a twice-a-week live series. Like a podcast with video and fun hacking. Focused on experiments. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Wednesdays and Sundays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "YVyjST8jhbA",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`In this episode we tried `}<a parentName="p" {...{
        "href": "https://nextjs.org/"
      }}>{`NextJS`}</a>{`, a React webapp framework, and built a small app. You can see it live at `}<a parentName="p" {...{
        "href": "https://swiz-cms.vercel.app/"
      }}>{`swiz-cms.vercel.app`}</a>{`.`}</p>
    <p>{`The ultimate goal for this app is to help folks create markdown articles. Copypasta is fine, but I always forget to change the title, write a description, add categories, and create a social card.`}</p>
    <p>{`In 55min we went from `}<em parentName="p">{`"Never tried NextJS before"`}</em>{` to a working app with a design system, forms, static rendering, and talking to an AWS Lambda to make cards. Not bad.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/191e2/The-end-resulthiibjh.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "85.20179372197309%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'341\\'%20viewBox=\\'0%200%20400%20341\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20171v170h401V0H0v171M23%2057l1%207h355V50H23v7m0%2042v6h28V92H23v7m11%20102v83h335V117H34v84m262-57c-26%205-45%2029-45%2057%200%208%202%2013%205%2014%204%200%205%203%201%203-3%200-3%200-3%203%202%205%204%207%208%207l4%202c1%201-1%202-4%202-3-1-2%200%202%206%204%205%206%206%206%203%200-2%202%200%204%204%202%205%209%209%2019%2010l7%202c10%203%2028-3%2039-13l5-5-14-3-3-1-3-2c-5%200-3-13%202-15%201%200%202-1%202-3%201-3%201-3%205-3s5%200%205-2c1-3%203-3%204%200s6%204%208%202l-2-1c-2%200-3-1-2-2l1-3c0-2%200-3%206-3%206-1%205-1-2-1-7-1-6-3%201-3h6l-1-6c0-6-4-19-8-25-3-4-7-6-14-7l-5-1v-5c-1-6-3-7-11-9-7-2-16-3-23-2m-10%2031l2%203c2%202%203%206%201%208v1h2l-3%2013v4c0%201%200%202-2%202s-3%202-3%205l2%202%205%202c3%203%205%203%209-1%203-2%203-2%204%200%202%204%2010%207%209%203v-1c3%203%202%206%200%205l-8%201c-3%201-7%202-8%201l-3%201c-1%202-19%201-19%200l4-2c4%200%208-7%204-8l-1-3c0-2%200-2-3-2-5%202-10%201-13%200-4-2-4-2-1%203l5%2013c3%2014%209%2024%2015%2024l2%201c2%202%2016%200%2019-2a109%20109%200%200014-28l5-13%201-2-3%202-8%202-4%201c0%201-1%202-3%202s-3-1-3-2l-2-4c-2-2-6-16-5-17l1-11c1-4%200-4-4-3h-8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/ca0a1/The-end-resulthiibjh.webp 223w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/75680/The-end-resulthiibjh.webp 445w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/8d1ba/The-end-resulthiibjh.webp 890w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/3838e/The-end-resulthiibjh.webp 1335w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/e11e5/The-end-resulthiibjh.webp 1780w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/00324/The-end-resulthiibjh.webp 1836w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/e92b6/The-end-resulthiibjh.png 223w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/e66bf/The-end-resulthiibjh.png 445w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/4ef49/The-end-resulthiibjh.png 890w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/4e814/The-end-resulthiibjh.png 1335w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/701e9/The-end-resulthiibjh.png 1780w", "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/191e2/The-end-resulthiibjh.png 1836w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8e6e8ab6efbc9b1deb2c1a6bc6e2d337/4ef49/The-end-resulthiibjh.png",
                "alt": "The end result",
                "title": "The end result",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`The end result`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "initial-setup"
    }}>{`Initial setup`}</h2>
    <pre><code parentName="pre" {...{}}>{`npx create-next-app swiz-cms
`}</code></pre>
    <p>{`That creates a plain ol' NextJS app. You get pleasant default styling, support for file-based routing, and server-side-rendering/generation out of the box.`}</p>
    <p>{`Means you can add a new page by creating a file in `}<inlineCode parentName="p">{`pages/file.js`}</inlineCode>{`. Anything in there becomes a page.`}</p>
    <p>{`You get support for building APIs out of the box via `}<inlineCode parentName="p">{`pages/api`}</inlineCode>{`, but we didn't try that on this stream. Next time 😉`}</p>
    <p>{`Wish you got MDX support out of the box. Makes for a better experience writing landing pages, product descriptions, and other content-heavy materials.`}</p>
    <p>{`I'm sure there's a plugin for that 🤔`}</p>
    <h2 {...{
      "id": "adding-a-design-system"
    }}>{`Adding a design system`}</h2>
    <p>{`I like to use `}<a parentName="p" {...{
        "href": "https://github.com/system-ui/theme-ui"
      }}>{`theme-ui`}</a>{` as a base for my design systems. Comes with flexible theming support and a great set of default components.`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn add theme-ui @theme-ui/presets
`}</code></pre>
    <p>{`Installs theme-ui and default presets with configured themes.`}</p>
    <p>{`In NextJS, you add a root `}<inlineCode parentName="p">{`<ThemeProvider>`}</inlineCode>{` in the `}<inlineCode parentName="p">{`_app.js`}</inlineCode>{` file. Lets you wrap the component tree and gives you access to theming anywhere in your app.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// pages/_app.js
import { ThemeProvider } from "theme-ui"
import theme from "../styles/theme"

function MyApp({ Component, pageProps }) {
  return (
    <ThemeProvider theme={theme}>
      <Component {...pageProps} />
    </ThemeProvider>
  )
}
`}</code></pre>
    <p>{`We created a custom theme in `}<inlineCode parentName="p">{`styles/theme.js`}</inlineCode>{` that extends from the `}<inlineCode parentName="p">{`deep`}</inlineCode>{` preset. Because deep's colors looked pretty :)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// styles/theme.js

import { deep } from "@theme-ui/presets"

export default {
  ...deep,
  sizes: {
    ...deep.sizes,
    container: 1024,
  },
}
`}</code></pre>
    <p>{`Custom container size means we can center our app with `}<inlineCode parentName="p">{`<Container> ... </Container>`}</inlineCode>{`. Might need to add more sizes to make it responsive.`}</p>
    <p>{`Yes, theme-ui has support for that 🤘`}</p>
    <h2 {...{
      "id": "creating-a-form"
    }}>{`Creating a form`}</h2>
    <p>{`Forms are notoriously difficult and that's why we used `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/why-reacthookform-is-my-new-favorite-form-library/"
      }}>{`my new favorite form library, react-hook-form`}</a>{`. It's great.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// components/FrontmatterForm.js

import { useForm } from "react-hook-form"
import { Label, Input, Textarea, Button } from "theme-ui"

export const FrontmatterForm = ({ onSubmit }) => {
  const { register, handleSubmit } = useForm()

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Label>Title</Label>
      <Input name="title" ref={register} />

      <Label>Description</Label>
      <Textarea name="description" ref={register} />

      <Button type="submit" bg="secondary">
        Submit
      </Button>
    </form>
  )
}
`}</code></pre>
    <p>{`Our form is simple – title and description – and react-hook-form made it even simpler. `}<inlineCode parentName="p">{`ref={register}`}</inlineCode>{` sets up state management machinery, theme-ui default components make it pretty.`}</p>
    <p>{`When you hit submit, the `}<inlineCode parentName="p">{`onSubmit`}</inlineCode>{` callback gets values in a dictionary.`}</p>
    <p>{`We put them in a `}<inlineCode parentName="p">{`useState`}</inlineCode>{` inside the main page.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// pages/index.js

export default function Home() {
    const [frontmatter, setFrontmatter] = useState(null);

    return (
        <>
            <Container>
                <h1>Swiz CMS is where articles are born</h1>

                <p>Use this to setup your copypasta for a new article</p>

                <FrontmatterForm onSubmit={setFrontmatter} />

                <Box sx={{ p: 4 }}>
                    {frontmatter ? <SocialCardImage {...frontmatter} /> : null}

                    {frontmatter ? <Frontmatter {...frontmatter} /> : null}
                </Box>
            </Container>
`}</code></pre>
    <p>{`FrontmatterForm returns data when it's ready, sets state, and re-renders the page. That shows 2 new result components.`}</p>
    <h2 {...{
      "id": "talking-to-a-serverless-function-on-aws-lambda"
    }}>{`Talking to a serverless function on AWS Lambda`}</h2>
    <p>{`We used `}<a parentName="p" {...{
        "href": "https://github.com/tannerlinsley/react-query"
      }}>{`react-query`}</a>{` for talking to a server. An AWS Lambda running my `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lambda-screenshot-as-a-service"
      }}>{`screenshot machinery`}</a>{` in this case.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// components/SocialCardImage.js

import { useQuery } from "react-query"
import { Image, Spinner } from "theme-ui"

async function fetchSocialCard(key, title) {
  const res = await fetch(
    \`https://pifc233qp6.execute-api.us-east-1.amazonaws.com/dev/social-card?title=\${title}\`
  )

  return res.json()
}

export const SocialCardImage = ({ title }) => {
  const cardQuery = useQuery(["social-card", title], fetchSocialCard)

  if (cardQuery.isLoading) {
    return <Spinner />
  }

  return <Image src={cardQuery.data.url} />
}
`}</code></pre>
    <p>{`React Query is like Apollo Client, but for REST. It's fantastic.`}</p>
    <p>{`You give your query a name, define a fetch function that returns data, and library handles the rest. Deals with caching, deduping, refetching, and coordination between different components making the same request.`}</p>
    <p>{`Proper article on React Query coming soon.`}</p>
    <h2 {...{
      "id": "verdict-on-nextjs"
    }}>{`Verdict on NextJS`}</h2>
    <p>{`👍`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      